// export function toHex(value: number | undefined, bytes: number | undefined) {
//     return bytes && value?.toString(16).padStart(bytes * 2, '0');
//   }

//  export function createObjectId(timestamp: number | undefined, machine: number | undefined, pid: number | undefined, increment: number | undefined) {
//     const timestampHex = toHex(timestamp, 4);
//     const machineHex = toHex(machine, 3);
//     const pidHex = toHex(pid, 2);
//     const incrementHex = toHex(increment, 3);
//     return (timestampHex && machineHex) && timestampHex + machineHex + pidHex + incrementHex
//   }


import { ObjectId } from 'bson';
import { userId } from '../inerface/iterface';

 export const createObjectId = (obj:userId|undefined) => {
    // Input object
 

    // Step 1: Convert timestamp to 4 bytes (8 hex chars)
    const timestampHex =obj?.timestamp && obj.timestamp.toString(16).padStart(8, '0');

    // Step 2: Convert machine ID to 3 bytes (6 hex chars)
    const machineHex = obj?.machine && obj.machine.toString(16).padStart(6, '0');

    // Step 3: Convert PID to 2 bytes (4 hex chars)
    const pidHex = obj?.pid && (obj.pid & 0xffff).toString(16).padStart(4, '0');

    // Step 4: Convert increment to 3 bytes (6 hex chars)
    const incrementHex =obj?.increment && obj.increment.toString(16).padStart(6, '0');

    // Step 5: Combine all parts to form the ObjectId
    const objectIdHex =machineHex && timestampHex && (timestampHex + machineHex + pidHex + incrementHex) ;

    // Convert hex string to MongoDB ObjectId using the bson library
    const objectId = new ObjectId(objectIdHex);
    return objectId.toHexString(); // return the hex string representation of ObjectId
  };
